'use client';

import Icon from '@/components/ui/AppIcon';
import { useRouter } from 'next/navigation';

interface ServicePillar {
  id: string;
  number: string;
  title: string;
  description: string;
  image: string;
  alt: string;
  whatsappMessage: string;
  serviceLink: string;
}

export default function ServicePillarsSection() {
  const router = useRouter();

  const pillars: ServicePillar[] = [
  {
    id: 'pillar_ppf',
    number: '01',
    title: 'PROTECCIÓN PPF',
    description: 'Paint Protection Film de grado militar con auto-regeneración',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_19fd6367a-1769683716835.png",
    alt: 'Aplicación profesional de laminado PPF en auto de lujo',
    whatsappMessage: 'Hola, quiero cotizar el servicio de Laminados PPF',
    serviceLink: '/services#ppf'
  },
  {
    id: 'pillar_ceramic',
    number: '02',
    title: 'CERAMIC COATING',
    description: 'Recubrimiento cerámico nano-tecnológico con brillo extremo',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_151fd7388-1766963033981.png",
    alt: 'Auto con ceramic coating mostrando brillo espejo',
    whatsappMessage: 'Hola, quiero cotizar el servicio de Recubrimiento Cerámico',
    serviceLink: '/services#ceramico'
  },
  {
    id: 'pillar_tinting',
    number: '03',
    title: 'LAMINADOS DE  CRISTALES',
    description: 'Laminado de cristales premium con rechazo UV 99%',
    image: "https://images.unsplash.com/photo-1663589714502-80bf7a6579c2",
    alt: 'Ventanas de auto con tintado profesional',
    whatsappMessage: 'Hola, quiero cotizar el servicio de Tintado de Cristales',
    serviceLink: '/services#tintado'
  },
  {
    id: 'pillar_detailing',
    number: '04',
    title: 'DETALLADO PROFESIONAL',
    description: 'Reacondicionamiento estético completo interior y exterior',
    image: "https://images.unsplash.com/photo-1726259578714-90b92c07873f",
    alt: 'Detailing profesional de auto de lujo',
    whatsappMessage: 'Hola, quiero cotizar el servicio de Detallado Profesional',
    serviceLink: '/services#detallado'
  }];

  const handleWhatsAppClick = (message: string) => {
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.link/4exlpx?text=${encodedMessage}`, '_blank');
  };

  const handleServiceClick = (serviceLink: string) => {
    router.push(serviceLink);
  };

  return (
    <section id="servicios" className="py-32 px-6 lg:px-12 bg-black">
      <div className="max-w-[1600px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white mb-6 tracking-tight uppercase">
            LOS 4 PILARES DE
            <br />
            <span className="text-[#E60000]">PROTECCIÓN TOTAL</span>
          </h2>
          <p className="text-white/60 text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
            Tecnología de competición aplicada a tu vehículo de lujo
          </p>
        </div>

        {/* Pillars Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pillars.map((pillar) =>
          <div
            key={pillar.id}
            onClick={() => handleServiceClick(pillar.serviceLink)}
            className="group relative aspect-[3/4] border border-white/10 bg-zinc-900 overflow-hidden cursor-pointer transition-all duration-500 hover:border-[#E60000]/50"
          >

              {/* Background Image */}
              <div className="absolute inset-0">
                <img
                src={pillar.image}
                alt={pillar.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />

                <div className="absolute inset-0 bg-black/70 group-hover:bg-black/50 transition-all duration-700" />
              </div>

              {/* Content */}
              <div className="absolute inset-0 p-8 flex flex-col justify-between z-10">
                {/* Number */}
                <span className="text-[#E60000] text-xs font-bold tracking-[0.5em] uppercase">
                  {pillar.number}
                </span>

                {/* Bottom Content */}
                <div>
                  <h3 className="text-2xl md:text-3xl font-bold text-white tracking-tight mb-3 uppercase">
                    {pillar.title}
                  </h3>
                  <p className="text-white/70 text-sm mb-6 leading-relaxed">
                    {pillar.description}
                  </p>
                  
                  {/* WhatsApp Button */}
                  <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleWhatsAppClick(pillar.whatsappMessage);
                  }}
                  className="w-full bg-[#E60000] hover:bg-white hover:text-black text-white px-6 py-3 text-xs font-bold tracking-[0.3em] uppercase transition-all duration-300 flex items-center justify-center gap-2">

                    <Icon name="ChatBubbleLeftRightIcon" size={16} variant="outline" />
                    COTIZAR
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}